import type { StatsConfig } from '@/components/composite/MediaViewer/components/MediaViewerStats/types';

import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { likesReceivedConfig } from '../likesReceived';

export const mediaViewerLikesConfig: StatsConfig = {
    ...likesReceivedConfig,
    id: 'like_count', // Override to match API field name
    type: 'kpi',
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
